const js2xmlparser = require("js2xmlparser");
const moment = require("moment");


//Removes attributes from the javascript object that have no value
function removeEmptyStringAttributes(obj) {
    for (const key in obj) {
        if (typeof obj[key] === 'object' && obj[key] !== null) {
            // Recurse into nested objects
            removeEmptyStringAttributes(obj[key]);
        } else if (obj[key] === '') {
            // Remove the attribute with an empty string
            delete obj[key];
        }
    }
}

//Replaces true and false with 1 and 0
function replaceBooleanWithBinary(obj) {
    const newObj = {};
    for (const key in obj) {
        if (typeof obj[key] === 'boolean') {
            newObj[key] = obj[key] ? '1' : '0';
        } else {
            newObj[key] = obj[key];
        }
    }
    return newObj;
}

//Replaces Date objects with strings in DD/MM/YYYY format
function replaceDatesWithShortString(obj) {
    function isDateFormattedString(string) {
        // Regular expression to match the format: YYYY-MM-DDTHH:mm:ss.SSSZ
        const regex = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\.\d{3}Z$/;
        return regex.test(string);
    }

    const newObj = {};
    function formatDate(date) {
        return moment(date).format('DD/MM/YYYY');
    }

    for (const key in obj) {
        if (obj[key] instanceof Date || (typeof obj[key] === 'string' && isDateFormattedString(obj[key]))) {
            newObj[key] = formatDate(obj[key]);
        } else {
            newObj[key] = obj[key];
        }
    }
    return newObj;
}

//Adds a prefix to all keys in the object
//We do this to make the XML output match what the iPad produces
function renameKeysWithPrefix(obj, prefix) {
    const newObj = {};
    for (const key in obj) {
        newObj[prefix + key] = obj[key];
    }
    return newObj;
}

//Generate XML that is basically the same as what comes out of the iPad app, based on enrolment data
export function generateXML(data) {
    let formattedData = {
        ...data.application,
        ...renameKeysWithPrefix(data.subscriber, 'application_to_Subscriber1.'),
        ...renameKeysWithPrefix(data.jointSubscriber, 'application_to_Subscriber2.'),
        ...renameKeysWithPrefix(data.beneficiary, 'application_to_Beneficiary.'),
        ...renameKeysWithPrefix(data.knowYourClient, 'application_to_KnowYourClient.'),
        ...renameKeysWithPrefix(data.common, 'application_to_Common.'),
        ...renameKeysWithPrefix(data.transfer, 'application_to_Transfer.'),
        ...renameKeysWithPrefix(data.dependant, 'application_to_Dependant1.'),
        ...renameKeysWithPrefix(data.dependant3, 'application_to_Dependant2.'),
        ...renameKeysWithPrefix(data.dependant3, 'application_to_Dependant3.'),
        ...renameKeysWithPrefix(data.dependant4, 'application_to_Dependant4.'),
        ...renameKeysWithPrefix(data.dependant5, 'application_to_Dependant5.'),
    }

    removeEmptyStringAttributes(formattedData);
    formattedData = replaceBooleanWithBinary(formattedData);
    formattedData = replaceDatesWithShortString(formattedData);

    let options = {
        format: {
            doubleQuotes: true
        },
        declaration: {
            include: false,
        },
        replaceInvalidChars: false,
        useSelfClosingTagIfEmpty: false, // Do not use self-closing tags for empty elements
        convertMap: {
            "[object Null]": function() {
                return undefined; // Convert null values to undefined, so they're not included in the XML
            },
            "[object Undefined]": function() {
                return undefined; // undefined so they're not included in the XML
            }
        }
    };

    return js2xmlparser.parse("enrolment", formattedData, options);
}